import { useCallback, useState } from 'react';

import { CollapsibleBase, MainTabEnum, NeighborhoodFilter } from '@rivallapp/volosports-components';
import toggleArrayItem from '../../../../../zustand-stores/DiscoverStore/utils/toggleArrayItem';
import useDiscoverStore from '../../../../../zustand-stores/DiscoverStore';
import { useUrlParams } from '../../../../../hooks';

const DiscoverNeighborhoodFilter = () => {
  const { updateUrlParams } = useUrlParams();

  const view = useDiscoverStore(store => store.view);
  const cityName = useDiscoverStore(store => store.filters.cityName);
  const selectedNeighborhoodIds = useDiscoverStore(store => store.filters.selectedNeighborhoodIds);

  const [collapsed, setCollapsed] = useState(!selectedNeighborhoodIds.length);
  const handlePress = () => setCollapsed(!collapsed);

  const onPressNeighborhood = useCallback(
    neighborhoodId => {
      updateUrlParams({
        neighborhoodIds: toggleArrayItem(selectedNeighborhoodIds, neighborhoodId),
      });
    },
    [updateUrlParams, selectedNeighborhoodIds]
  );

  const isRental = view === MainTabEnum.COURT_RENTALS;

  return (
    <CollapsibleBase title="Neighborhoods" isCollapsed={collapsed} onPress={handlePress}>
      <NeighborhoodFilter
        cityName={cityName}
        isRental={isRental}
        onPress={onPressNeighborhood}
        selectedNeighborhoodIds={selectedNeighborhoodIds}
      />
    </CollapsibleBase>
  );
};

export default DiscoverNeighborhoodFilter;
